module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/kind_icons/bracket-fcf93a9cd450ab8d8e8241726cea82c1.svg";